import DashboardLayout from "@/views/Layout/DashboardLayout.vue";
import NoLayout from "@/views/Layout/NoLayout.vue";

// middleware
import auth from "./middleware/auth";
import guest from "./middleware/guest";
import inBusiness from "@/router/middleware/inBusiness";
import notInBusiness from "@/router/middleware/notInBusiness";
import cartNotEmpty from "@/router/middleware/cartNotEmpty";
import induction from "@/router/middleware/induction";

const routes = [
  {
    path: "/login",
    component: NoLayout,
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/Auth/Login.vue"),
        meta: {
          middleware: guest,
          permissions: []
        }
      },
      {
        path: "/registration",
        name: "Registration",
        component: () => import("@/views/Auth/Registration.vue"),
        meta: {
          middleware: guest,
          permissions: []
        }
      },
      {
        path: "/reg_confirmation",
        name: "Registration Confirmation",
        component: () => import("@/views/Auth/RegistrationConfirmation.vue"),
        meta: {
          middleware: guest,
          permissions: []
        }
      },
      {
        path: "/logout",
        name: "Logout",
        component: {
          render() {},
          created() {
            this.$store.dispatch("logout").then(() => {
              this.$router.push({ path: "/login" });
            });
          }
        },
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "/parking-pass",
        name: "Parking Pass",
        component: () => import("@/views/ParkingPass.vue"),
        meta: {
          middleware: guest,
          permissions: []
        }
      }
    ]
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Hub",
        component: () => import("@/views/Dashboard.vue"),
        meta: {
          middleware: [auth, induction],
          permissions: []
        }
      },
      {
        path: "account",
        name: "Account Details",
        component: () => import("@/views/Account.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "business",
        name: "Business Details",
        component: () => import("@/views/Business/Business.vue"),
        meta: {
          middleware: [auth, inBusiness],
          permissions: ["view own business"]
        }
      },
      {
        path: "access-passes",
        name: "Access Passes",
        component: () => import("@/views/Subscriptions.vue"),
        meta: {
          middleware: [auth, inBusiness]
          // permissions: ["manage employees"]
        }
      },
      {
        path: "media",
        name: "Media Database",
        component: () => import("@/views/MediaDatabase.vue"),
        meta: {
          middleware: [auth, induction],
          permissions: []
        }
      },
      {
        path: "billing",
        name: "Billing History",
        component: () => import("@/views/BillingHistory.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      // {
      //   path: "marketplace",
      //   name: "Marketplace",
      //   component: () => import("@/views/Marketplace.vue"),
      //   meta: {
      //     middleware: auth,
      //     permissions: [],
      //     hideFooter: true
      //   }
      // },
      {
        path: "markettours",
        name: "Market Tours",
        component: () => import("@/views/MarketTours.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "advertising",
        name: "Advertising at the Markets",
        component: () => import("@/views/Advertising.vue"),
        meta: {
          middleware: [],
          permissions: []
        }
      },
      {
        path: "enquiry",
        name: "Enquiry",
        component: () => import("@/views/Enquiry.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "whsmanagement",
        name: "WHS Management Plan",
        component: () => import("@/views/WHSInformation/WHSManagementPlan.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "safetynotices",
        name: "Safety Notices",
        component: () => import("@/views/WHSInformation/SafetyNotices.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      {
        path: "induction",
        name: "Induction",
        component: () => import("@/views/WHSInformation/Induction.vue"),
        meta: {
          middleware: auth,
          permissions: []
        }
      },
      // {
      //   path: "recipes",
      //   name: "Recipes",
      //   component: () => import("@/views/Recipes.vue"),
      //   meta: {
      //     middleware: auth,
      //     permissions: []
      //   }
      // },
      {
        path: "cart",
        name: "Cart",
        component: () => import("@/views/Checkout/Cart.vue"),
        meta: {
          middleware: [auth, inBusiness]
          // permissions: ["manage employees"]
        }
      },
      {
        path: "checkout",
        name: "Checkout",
        component: () => import("@/views/Checkout/Checkout.vue"),
        meta: {
          middleware: [auth, inBusiness, cartNotEmpty]
          // permissions: ["manage employees"]
        }
      },
      {
        path: "order-confirmation",
        name: "Order Confirmation",
        component: () => import("@/views/Checkout/OrderConfirmation.vue"),
        meta: {
          middleware: auth
          // permissions: ["manage employees"]
        }
      }
    ]
  },
  {
    path: "/",
    component: NoLayout,
    children: [
      {
        path: "business-registration",
        name: "Business Registration",
        component: () => import("@/views/Business/NewBusiness.vue"),
        meta: {
          middleware: [auth, notInBusiness],
          permissions: ["create business"]
        }
      },
      {
        path: "confirm-business",
        name: "Confirm Business Details",
        component: () => import("@/views/Business/ConfirmBusiness.vue"),
        meta: {
          middleware: [auth, inBusiness],
          permissions: ["update own business"]
        }
      },
      {
        path: "guest-induction",
        name: "Guest Induction",
        component: () => import("@/views/WHSInformation/GuestInduction.vue"),
        meta: {
          permissions: []
        }
      },
      {
        path: "/403",
        name: "Forbidden",
        component: () => import("@/views/Error/403.vue")
      },
      {
        path: "/:catchAll(.*)",
        name: "Not Found",
        component: () => import("@/views/Error/404.vue")
      }
    ]
  }
];

export default routes;
